<template>
  <v-data-table
    :headers="headers"
    :items="filteredAcks"
    :search="search"
  >
    <template v-slot:item.avatar="{ item }" >
      <Avatar :employee="item.employee" :size="30" :hideHeadline="true" />
    </template>
    <template v-slot:item.employee.fields.Name="{ item }" >
      <router-link 
        :to="{ name: 'Employee', params: { id: item.employee.id } }"
      >
      {{ item.employee.fields.Name }}
      <v-chip
        x-small
        v-bind="attrs" v-on="on"
        v-if="item.employee.fields.Status === 'Inactive'" 
        class="error text-uppercase"
      >Inactive</v-chip>
      </router-link>
    </template>
    <template v-slot:item.time="{ item }">
      <span v-if="type === 'awaiting'"></span>
      <span v-else-if="type === 'incomplete'">
        {{ getTimeSince(item.fields['Created Time']) }}
      </span>
      <span v-else>
        {{ formatDatetime(item.fields['Acknowledged Date Time']) }}
      </span>
    </template>
    <template v-slot:item.reminded="{ item }">
      <span>
        {{ getLastRemindedTime(item) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
  import moment from 'moment'
  import Avatar from '@/components/employee/Avatar'
  
  export default {
    name: 'AcknowledgementTable',
    props: {
      acknowledgements: Array,
      search: String,
      type: String
    },
    components: {
      Avatar
    },
    data () {
      return {
        headers: [
          {
            text: '',
            sortable: false,
            value: 'avatar'
          },
          {
            text: 'Name',
            sortable: true,
            value: 'employee.fields.Name'
          },
          {
            text: 'Email',
            sortable: true,
            value: 'employee.fields.Email'
          },
          {
            text: 'Department',
            sortable: true,
            value: 'employee.fields.Department'
          }
        ]
      }
    },
    computed: {
      filteredAcks () {
        if (this.acknowledgements) {
          return this.acknowledgements.filter(a => {
            return a.employee
          })
        }
        return []
      }
    },
    created () {
      switch (this.type) {
        case 'incomplete':
          this.headers.push({
            text: 'Requested',
            sortable: false,
            value: 'time'
          }, {
            text: 'Last Reminded',
            sortable: false,
            value: 'reminded'
          })
          break
        case 'complete':
          this.headers.push({
            text: 'Completed',
            sortable: false,
            value: 'time'
          })
          break
      }
    },
    methods: {
      getTimeSince (datetime) {
        const d = moment(datetime)
        return moment(d).fromNow()
      },
      getLastRemindedTime (ack) {
        if (ack.fields['Last Reminded']) {
          const d = moment(ack.fields['Last Reminded'])
          return moment(d).fromNow()
        }
        return 'Never'
      },
      formatDatetime (datetime) {
        const d = moment(datetime)
        return moment(d).format('LLL')
      }
    }
  }
</script>
